import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ProjectView = lazy(
  () => import("@/features/projects/project/view/index.tsx"),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/projects/$projectId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ProjectView />
    </Suspense>
  );
}
